export default "/_next/static/images/charts@2x-78c7aa830db70431b7fc6a45e76218aa.webp";